import { useAtomValue } from 'jotai';

import { userDataAtom } from 'src/stores/auth/atoms';

export default function useUserData() {
  const userData = useAtomValue(userDataAtom);
  return userData;
}
